import { render, staticRenderFns } from "./CommonOverlaySection.vue?vue&type=template&id=748f28bb"
import script from "./CommonOverlaySection.vue?vue&type=script&lang=ts"
export * from "./CommonOverlaySection.vue?vue&type=script&lang=ts"
import style0 from "./CommonOverlaySection.vue?vue&type=style&index=0&id=748f28bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports